import { collection, deleteDoc, doc, getDocs, query, setDoc, where } from "firebase/firestore";
import { db } from "@/firebase/config";
import type { RoundBonusRepository } from "@/modules/leagues/repositories/RoundBonusRepository";
import type { RoundBonus, RoundBonusType } from "@/modules/leagues/types/roundBonus";

/**
 * `groups/{leagueId}/roundBonuses/{matchId}` — um doc por partida com bônus
 * ativo. Ausência de doc = "Normal". Escrita restrita a admin da liga nas
 * Firestore Rules (afeta pontuação real, não é um ajuste cosmético).
 */
export class FirestoreRoundBonusRepository implements RoundBonusRepository {
  private collection(leagueId: string) {
    return collection(db, "groups", leagueId, "roundBonuses");
  }

  async getRoundBonuses(leagueId: string, round: number): Promise<RoundBonus[]> {
    const snap = await getDocs(query(this.collection(leagueId), where("round", "==", round)));
    return snap.docs.map((d) => d.data() as RoundBonus);
  }

  async setRoundBonus(leagueId: string, matchId: string, round: number, type: RoundBonusType | null): Promise<void> {
    const ref = doc(this.collection(leagueId), matchId);
    if (type === null) {
      await deleteDoc(ref);
      return;
    }
    await setDoc(ref, { matchId, round, type });
  }
}
